export const createSFTPProcessing = `mutation CreateSFTPProcessing($input: CreateSFTPProcessingInput!) {
  createSFTPProcessing(input: $input) {
    id
    companyId
    companyName
    createdDate
    file
    status
    syncType
    logs
  }
}
`;
